export default __webpack_public_path__ + "static/media/logo_gpm.6c50f459.png";